// TODO: jsDocを書く
import { ValidateRules, ValidateFunction } from '@/coreDomainsModule/table';
import tippy from 'tippy.js';
import { i18n } from '@/i18n';
// import '../assets/css/alertTheme.css';
import '../../assets/css/validate.css';
import '../../assets/css/app.css';
interface Field {
  key: string;
  label: string;
  type: string;
}

interface GeneralField {
  key: string;
  label: string;
  require: boolean;
  min: number | null;
  max: number | null;
  type: string;
}

interface ValidationNg {
  key: string;
  warningText: string;
}

interface Instances {
  [key: string]: any;
}

/**
 * GeneralField型のinterfaceをfield型とvalidate型に分ける
 * @param generalFields ''
 */
const separateFields = (generalFields: GeneralField[]) => {
  // GeneralField型のinterfaceをfield型とvalidate型に分ける
  const fields: Field[] = [];
  const validates: ValidateRules = {};
  for (const generalField of generalFields) {
    const field = {};
    if (generalField.key) {
      validates[generalField.key] = { require: false };
      for (const [key, value] of Object.entries(generalField)) {
        if (key == 'require' || key == 'min' || key == 'max') {
          // validate
          validates[generalField.key][key] = value;
        } else {
          // field
          field[key] = value;
        }
      }
    }
  }
  return { fields: fields, validates: validates };
};

/**
 *
 */
class Validate {
  private validateRule: ValidateRules = {};
  status = false;
  ngs: ValidationNg[] = [];
  private tippyInstances: Instances = {};
  targetId = 'modal'; // tippyを出したいDOMのIDを指定する
  CONSTANT_X = 10;
  adjustX = this.CONSTANT_X;
  adjustY = 0;
  kindSetting = true;
  private tooltipHeight = 30;

  /**
   * ''
   * @param validateRule ''
   * @param targetId ''
   * @param kindSetting ''
   */
  constructor(validateRule: ValidateRules | null = null, targetId = 'modal', kindSetting = true) {
    // validateルールで初期化する
    this.kindSetting = kindSetting;
    this.targetId = targetId;
    if (validateRule) {
      this.setValidateRule(validateRule);
    }
  }

  /**
   * ''
   * @param validateRules ''
   */
  setValidateRule(validateRules: ValidateRules) {
    this.validateRule = validateRules;
    if (this.kindSetting) {
      this.setKindLimitValidateRule();
    }
  }
  private setKindLimitValidateRule() {
    // minLabelとmaxLabelがなければ探索してつけてくれる
    for (const key of Object.keys(this.validateRule)) {
      if (!this.validateRule[key].minLabel && this.validateRule[key].min) {
        this.validateRule[key].minLabel = String(this.validateRule[key].min);
      }
      if (!this.validateRule[key].maxLabel && this.validateRule[key].max) {
        this.validateRule[key].maxLabel = String(this.validateRule[key].max);
      }
    }
  }
  private calculatePosition() {
    const targetElement = document.getElementById(this.targetId);
    if (!targetElement) {
      return;
    }
    this.adjustY += -(targetElement.clientHeight / 2 - this.tooltipHeight / 2);
  }
  /**
   * ''
   * @param formSet '
   * @param targetFields '
   * @param validateRules '
   */
  inspect(formSet: { [key: string]: any }, targetFields: Field[], validateRules: ValidateRules | null = null) {
    // ルールにしたがってバリデーション実行
    this.initInspectedData();
    this.initAdjustY(); // バリデーションの位置の変更がある場合
    this.initInstances();
    this.calculatePosition();
    this.status = true;
    let targetValidateRule = this.validateRule;
    let fields: Field[] = [];
    fields = targetFields;
    if (validateRules) {
      targetValidateRule = validateRules;
    }
    for (const field of fields) {
      if (targetValidateRule[field.key]) {
        // requireCheck
        if (targetValidateRule[field.key].require && formSet[field.key] === undefined) {
          this.status = false;
          const warningText = String(i18n.t('isRequired', { value: field.label }));
          this.ngs.push({ key: field.key, warningText: warningText });
        }
        if (
          targetValidateRule[field.key].min !== undefined &&
          formSet[field.key] < (targetValidateRule[field.key].min as number) /* 前の条件でundefinedはない*/
        ) {
          this.status = false;
          const warningText = String(i18n.t('greaterThanOrEqualMin', { value: field.label, min: targetValidateRule[field.key].minLabel }));
          this.ngs.push({ key: field.key, warningText: warningText });
        }
        if (targetValidateRule[field.key].func !== undefined) {
          const result: [boolean, string] = (targetValidateRule[field.key] as ValidateFunction).func(field.key, formSet[field.key]);
          if (!result[0]) {
            this.status = false;
            this.ngs.push({ key: field.key, warningText: result[1] });
          }
        }
      }
    }
    return this.status;
  }
  private enTippy(id: string, content: string, adjustY = this.adjustY, adjustX = this.adjustX) {
    // alertを一つ出す
    if (this.tippyInstances.hasOwnProperty(id)) {
      this.tippyInstances[id].show();
    } else {
      const instance = tippy(`#${this.targetId}`, {
        content: content,
        trigger: 'manual',
        arrow: true,
        theme: 'validate',
        role: 'tooltip',
        placement: 'right',
        offset: [adjustY, adjustX],
      });
      if (Array.isArray(instance) && instance.length > 0) {
        this.tippyInstances[id] = instance[0];
        instance[0].show();
      }
    }
  }
  /**
   *
   */
  showTippys() {
    // alertをngsの数出す
    let y = this.adjustY;
    for (let i = 0; i < this.ngs.length; i++) {
      const ng = this.ngs[i];
      this.enTippy('id' + i, ng.warningText, y);
      y += this.tooltipHeight + 5;
    }
  }
  /**
   *
   */
  hideTippys() {
    // alertを全て非表示にする
    for (const instanceKey of Object.keys(this.tippyInstances)) {
      const instance = this.tippyInstances[instanceKey];
      instance.hide();
    }
  }
  /**
   *
   */
  initInspectedData() {
    this.status = false;
    this.ngs = [];
  }
  /**
   *
   */
  initValidateRules() {
    this.validateRule = {};
  }
  /**
   *
   */
  initInstances() {
    this.tippyInstances = {};
  }
  /**
   *
   */
  initAdjustY() {
    this.adjustY = 0;
  }
  /**
   *
   */
  initAdjustX() {
    this.adjustX = this.CONSTANT_X;
  }
  /**
   *
   * @param adjust '
   */
  setAdjustX(adjust: number) {
    this.adjustX = adjust;
  }
  /**
   *
   */
  init() {
    this.initInspectedData();
    this.initValidateRules();
    this.initInstances();
    this.initAdjustY();
    this.initAdjustX();
  }
}

let rules: any;

/**
 *
 * @param r '
 */
export const setRule = (r: any) => (rules = r);

/**
 * ''
 * @param state '
 * @param param '
 */
export const getValidateFunctions = (state?: any, param?: string) => {
  const errorOutput = (v) => {
    for (const r in rules[v.$path]) {
      if (!v[r].$invalid) continue;
      switch (r) {
        case 'required':
          if (v[r].$model === '') return 'ここは入力必須のフィールドです';
          break;
        case 'minLength':
          if (typeof v[r].$params.min !== 'undefined') return `${v[r].$params.min}文字以上の英数字にしてください`;
          break;
        case 'sameAsPassword':
          return '同じパスワードを入力してください';
        case 'passwordPolicy':
          return 'アルファベット大文字、小文字と数字をすべて含めてください';
      }
    }
    return '';
  };

  const reValidate = (v) => {
    // TODO: 本来こんな処理は必要ないはずだが、vuelidateとquasarの相性が悪いのか、他方のvalidationが動かないので強制リセットしてvalidatorを動かす
    if (!v.$dirty) return;
    v.$reset();
    v.$touch();
  };

  const sameAs = (value) => {
    if (state && param) {
      return value === state[param];
    }
    return true;
  };

  const passwordPolicy = (value) => {
    const lower = /[a-z]+/.test(value);
    const upper = /[A-Z]+/.test(value);
    const numeric = /[0-9]+/.test(value);
    return lower && upper && numeric;
  };
  return {
    errorOutput,
    sameAs,
    passwordPolicy,
    reValidate,
  };
};
export { separateFields, Validate };
